import { useContext, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { BillingItem, Card, CardTitle, Pagination, useFetch } from '@reveni-io/reveni-ui'
import { BillingTransactionsTable } from '@reveni-io/reveni-ui'

import billingServices from '@/billing/services/services'
import AppContext from '@/common/context/app.context'
import useFilters from '@/common/hooks/useFilters/useFilters'

import BillingDetailPageSkeleton from './BillingDetailPageSkeleton/BillingDetailPageSkeleton'
import BillingTransactionsTableSkeleton from './BillingTransactionsTableSkeleton/BillingTransactionsTableSkeleton'
import Header from './Header/Header'
import { filterNames, filters } from './constants'
import * as Styles from './styles'

const BillingDetailPage = () => {
  const { id } = useParams()
  const { info } = useContext(AppContext)
  const prevIdRef = useRef()

  const {
    data,
    loading,
    fetchData: fetchTransactions,
  } = useFetch(billingServices.getInvoiceTransactions, { doInitialRequest: false })

  const {
    data: invoiceData,
    fetchData: fetchInvoiceData,
    loading: invoiceLoading,
  } = useFetch(billingServices.getInvoiceDetail, {
    doInitialRequest: false,
  })

  const { updateFilter, page } = useFilters({
    filters: filters,
    doInitialRequest: true,
    filterValues: { [filterNames.page]: 1 },
    fetchData: params => fetchTransactions({ invoiceId: id, storeId: info.selectedStore.id, params }),
    nameOfFiltersInContext: 'billingDetailFilters',
  })

  useEffect(() => {
    if (prevIdRef.current !== id && page) {
      fetchInvoiceData({ invoiceId: id, storeId: info.selectedStore.id })
      updateFilter(filterNames.page, 1)
      prevIdRef.current = id
    }
  }, [id, fetchInvoiceData, info.selectedStore.id, updateFilter, page])

  const { t } = useTranslation()

  if (invoiceLoading) return <BillingDetailPageSkeleton />

  return (
    <Styles.Container>
      <Header invoice={invoiceData} />
      <BillingItem invoice={invoiceData} currency={invoiceData?.total_amount_currency} />
      <Styles.TransactionsContainer>
        <Card showBorder={false}>
          <CardTitle>{t('Desglose')}</CardTitle>
          {loading ? (
            <BillingTransactionsTableSkeleton />
          ) : (
            <BillingTransactionsTable transactions={data?.results} currency={invoiceData?.total_amount_currency} />
          )}
          <Styles.PaginationContainer>
            <Pagination
              count={Math.ceil(data?.count / 20)}
              page={page}
              next={data?.next}
              previous={data?.previous}
              onChangePage={page => updateFilter(filterNames.page, page)}
            />
          </Styles.PaginationContainer>
        </Card>
      </Styles.TransactionsContainer>
    </Styles.Container>
  )
}

export default BillingDetailPage
